import OTPFieldBasedOnType from './OTPFieldBasedOnType';

export default OTPFieldBasedOnType;
